import * as React from "react";
import { Container, Grid, Link, Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import useUI from "../hooks/useUI";
import useTranslation from "../hooks/translations";

const useStyles = makeStyles((theme: any) => ({
  root: {
    margin: "0 auto",
    bottom: 0,
    left: 0,
    width: "100%",
    paddingBottom: theme.spacing(1),
    textAlign: "center",
  },
}));

const Footer = () => {
  const { isMobileMode } = useUI();
  const classes = useStyles();
  const year = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <>
      <Grid
        className={classes.root}
        component="footer"
        sx={{
          py: 3,
          px: 2,
          mt: "auto",
        }}
      >
        <Container maxWidth="md">
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: isMobileMode ? "column" : "column",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                mr: 1,

                fontSize: isMobileMode ? "11px" : "12px",
              }}
            >
              ©2012 - {year} {t("allRightsReserved")}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mr: 1,
                fontWeight: 600,
                fontSize: isMobileMode ? "11px" : "12px",
              }}
            >
              {t("securedPlatform")}
            </Typography>
            <Typography sx={{ fontSize: "12px" }}>
              <Link
                sx={{ textDecoration: "underline", marginRight: 1 }}
                underline="none"
                href={"https://enkap.cm/politique-de-confidentialite/"}
              >
                {" "}
                {t("privacyPolicy")}
              </Link>
              {"   "}
              <Link
                sx={{ textDecoration: "underline" }}
                underline="none"
                href={"https://enkap.cm/politique-de-confidentialite/"}
              >
                {t("termsOfService")}
              </Link>
            </Typography>
          </Box>
        </Container>
      </Grid>
    </>
  );
};
export default Footer;
